import { useTranslation } from 'react-i18next';

import { Tag } from '~/components';
import { cn } from '~/lib/cn';

import { ArtistFilterTagTooltip } from '../../ArtistFilterTagTooltip';
import { SELECTED_TAG_CLASSES } from '../constants';

interface ArtistOnRosterFilterProps {
  isOnRoster?: boolean;
  onSelect: (isOnRoster?: boolean) => void;
}

export const ArtistOnRosterFilter = ({
  isOnRoster,
  onSelect,
}: ArtistOnRosterFilterProps) => {
  const { t } = useTranslation('roster');

  return (
    <div className="flex gap-sm py-sm">
      <Tag
        asChild
        variant="secondary"
        className={cn({
          [SELECTED_TAG_CLASSES]: isOnRoster === undefined,
        })}
        onClick={() => {
          onSelect(undefined);
        }}
        aria-pressed={isOnRoster === undefined}
      >
        <button>{t('all.label')}</button>
      </Tag>
      <Tag
        asChild
        variant="secondary"
        className={cn({
          [SELECTED_TAG_CLASSES]: isOnRoster,
        })}
        onClick={() => {
          onSelect(true);
        }}
        aria-pressed={isOnRoster === true}
      >
        <button>
          {t('filters.onRoster.label')}
          <ArtistFilterTagTooltip
            trans={{ i18nKey: 'filters.onRoster.tooltip' }}
          />
        </button>
      </Tag>
      <Tag
        asChild
        variant="secondary"
        className={cn({
          [SELECTED_TAG_CLASSES]: isOnRoster === false,
        })}
        onClick={() => {
          onSelect(false);
        }}
        aria-pressed={isOnRoster === false}
      >
        <button>
          {t('filters.offRoster.label')}
          <ArtistFilterTagTooltip
            trans={{ i18nKey: 'filters.offRoster.tooltip' }}
          />
        </button>
      </Tag>
    </div>
  );
};

ArtistOnRosterFilter.displayName = 'ArtistOnRosterFilter';
